import { authMenu, dashboardMenu, loansMenu, management } from 'menu';
import React, { lazy } from 'react';

const AUTH = {
	LOGIN: lazy(() => import('pages/presentation/auth/Login')),
	FORGET_PASSWORD: lazy(() => import('pages/presentation/auth/Forget')),
	CONFIRM_RESET: lazy(() => import('pages/presentation/auth/ConfirmForget')),
	RESET: lazy(() => import('pages/presentation/auth/ResetPassword')),
	JOIN_TEAM: lazy(() => import('pages/presentation/auth/JoinTeam')),
};

const LANDING = {
	DASHBOARD: lazy(() => import('pages/presentation/dashboard/DashboardPage')),
	EXECUTIVE_DASHBOARD: lazy(() => import('pages/presentation/dashboard/ExecutiveDashboardPage')),
	AGENTS: {
		INDEX: lazy(() => import('pages/presentation/dashboard/users/Agents')),
		SHOW_AGENT: lazy(() => import('pages/presentation/dashboard/users/AgentSingle')),
	},
	CUSTOMERS: {
		INDEX: lazy(() => import('pages/presentation/dashboard/users/Customers')),
		SHOW_CUSTOMER: lazy(() => import('pages/presentation/dashboard/users/CustomerSingle')),
	},
	PRODUCTS: {
		INDEX: lazy(() => import('pages/presentation/dashboard/product/Products')),
		SHOW_PRODUCT: lazy(() => import('pages/presentation/dashboard/product/SingleProduct')),
	},
	BRANCHES: {
		INDEX: lazy(() => import('pages/presentation/dashboard/branches/Branches')),
		SHOW_BRANCH: lazy(() => import('pages/presentation/dashboard/branches/SingleBranch')),
	},
	NOTIFICATIONS: lazy(() => import('pages/presentation/dashboard/notifications/Notifications')),
	SMS: lazy(() => import('pages/presentation/dashboard/notifications/SendSms')),
	UPLOAD_SALARY: lazy(() => import('pages/presentation/dashboard/salaries/UploadSalaryNow')),
	SALARY_INDEX: lazy(() => import('pages/presentation/dashboard/salaries/SalaryHistory')),
	REPORT: lazy(() => import('pages/presentation/dashboard/reports/Reports')),
};

const PROFILE = {
	PROFILE: lazy(() => import('pages/presentation/profile/Profile')),
};

const LOAN_MENU = {
	PUBLIC_LOAN: lazy(() => import('pages/presentation/loans/Loans')),
	PUBLIC_SINGLE: lazy(() => import('pages/presentation/loans/SingleLoan')),
};

const ADMINISTRATION = {
	ROLES: lazy(() => import('pages/presentation/administrators/Role/Roles')),
	SINGLE_ROLE: lazy(() => import('pages/presentation/administrators/Role/SingleRole')),
	SINGLE_INVITE: lazy(() => import('pages/presentation/administrators/Admin/SingleInvite')),
	STAFF: lazy(() => import('pages/presentation/administrators/Admin/Administrators')),
	SINGLE_STAFF: lazy(() => import('pages/presentation/administrators/Admin/SingleTeam')),
};

const presentation = [
	/**
	 * Auth
	 */
	{
		path: authMenu.login.path,
		element: <AUTH.LOGIN />,
		exact: true,
	},
	{
		path: authMenu.forgetGroup.subMenu.forgetPassword.path,
		element: <AUTH.FORGET_PASSWORD />,
		exact: true,
	},
	{
		path: `${authMenu.joinTeam.path}/:slug`,
		element: <AUTH.JOIN_TEAM />,
		exact: true,
	},
	{
		path: authMenu.forgetGroup.subMenu.confirmation.path,
		element: <AUTH.CONFIRM_RESET />,
		exact: true,
	},
	{
		path: authMenu.forgetGroup.subMenu.resetPassword.path,
		element: <AUTH.RESET />,
		exact: true,
	},
	/**
	 * Landing
	 */
	{
		path: dashboardMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
		exact: true,
	},
	{
		path: dashboardMenu.executiveDashboard.path,
		element: <LANDING.EXECUTIVE_DASHBOARD />,
		exact: true,
	},
	{
		path: dashboardMenu.agents.path,
		element: <LANDING.AGENTS.INDEX />,
		exact: true,
	},
	{
		path: `${dashboardMenu.agents.path}/:id`,
		element: <LANDING.AGENTS.SHOW_AGENT />,
		exact: true,
	},
	{
		path: dashboardMenu.customers.path,
		element: <LANDING.CUSTOMERS.INDEX />,
		exact: true,
	},
	{
		path: `${dashboardMenu.customers.path}/:id`,
		element: <LANDING.CUSTOMERS.SHOW_CUSTOMER />,
		exact: true,
	},
	{
		path: dashboardMenu.products.path,
		element: <LANDING.PRODUCTS.INDEX />,
		exact: true,
	},
	{
		path: `${dashboardMenu.products.path}/:id`,
		element: <LANDING.PRODUCTS.SHOW_PRODUCT />,
		exact: true,
	},
	{
		path: dashboardMenu.branches.path,
		element: <LANDING.BRANCHES.INDEX />,
		exact: true,
	},
	{
		path: `${dashboardMenu.branches.path}/:id`,
		element: <LANDING.BRANCHES.SHOW_BRANCH />,
		exact: true,
	},
	{
		path: dashboardMenu.notifications.path,
		element: <LANDING.NOTIFICATIONS />,
		exact: true,
	},
	{
		path: dashboardMenu.sms.path,
		element: <LANDING.SMS />,
		exact: true,
	},
	{
		path: dashboardMenu.upload.path,
		element: <LANDING.UPLOAD_SALARY />,
		exact: true,
	},
	{
		path: dashboardMenu.uploadSalaryLists.path,
		element: <LANDING.SALARY_INDEX />,
		exact: true,
	},
	{
		path: dashboardMenu.reports.path,
		element: <LANDING.REPORT />,
		exact: true,
	},
	/**
	 * Profile
	 */
	// {
	// 	path: profileMenu.profile.path,
	// 	element: <PROFILE.PROFILE />,
	// 	exact: true,
	// },
	/**
	 * Loan Menu
	 */
	{
		path: loansMenu.loans.path,
		element: <LOAN_MENU.PUBLIC_LOAN />,
		exact: true,
	},
	{
		path: `${loansMenu.loans.path}/:id`,
		element: <LOAN_MENU.PUBLIC_SINGLE />,
		exact: true,
	},
	/**
	 * Administration
	 */
	/**
	 * ADMINISTRATION
	 */
	{
		path: management.roles.path,
		element: <ADMINISTRATION.ROLES />,
		exact: true,
	},
	{
		path: `${management.roles.path}/:id`,
		element: <ADMINISTRATION.SINGLE_ROLE />,
		exact: true,
	},
	{
		path: `${management.administrators.path}/invites/:id`,
		element: <ADMINISTRATION.SINGLE_INVITE />,
		exact: true,
	},
	{
		path: management.administrators.path,
		element: <ADMINISTRATION.STAFF />,
		exact: true,
	},
	{
		path: `${management.administrators.path}/:id`,
		element: <ADMINISTRATION.SINGLE_STAFF />,
		exact: true,
	},
	{
		path: `/profile`,
		element: <PROFILE.PROFILE />,
		exact: true,
	},
];
const contents = [...presentation];

export default contents;
